import Vue from 'vue'
import Router from 'vue-router'

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: resolve => require(['@/pages/login'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: false,
                showHeader: false,
            }
        },
        {
            path: '/activity',
            name: 'activity',
            component: resolve => require(['@/pages/activity/index'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/addActive',
            name: 'addActive',
            component: resolve => require(['@/pages/activity/addActive'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/editActive/:id/:state',
            name: 'editActive',
            component: resolve => require(['@/pages/activity/editActive'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/giftManage',
            name: 'giftManage',
            component: resolve => require(['@/pages/giftManage/index'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/addGift',
            name: 'addGift',
            component: resolve => require(['@/pages/giftManage/add'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/editGift/:id/:state',
            name: 'editGift',
            component: resolve => require(['@/pages/giftManage/edit'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/message',
            name: 'message',
            component: resolve => require(['@/pages/message/index'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/editor/:id',
            name: 'editor',
            component: resolve => require(['@/pages/message/editor'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/add',
            name: 'add',
            component: resolve => require(['@/pages/message/add'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/appPush',
            name: 'appPush',
            component: resolve => require(['@/pages/appPush/index'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/editorPush/:id',
            name: 'editorPush',
            component: resolve => require(['@/pages/appPush/editorPush'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/addPush',
            name: 'addPush',
            component: resolve => require(['@/pages/appPush/addPush'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/lookPush/:id',
            name: 'lookPush',
            component: resolve => require(['@/pages/appPush/lookPush'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/appMessage',
            name: 'appMessage',
            component: resolve => require(['@/pages/appMessage/index'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/editorApp/:id',
            name: 'editorAPP',
            component: resolve => require(['@/pages/appMessage/editorAPP'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/addApp',
            name: 'addApp',
            component: resolve => require(['@/pages/appMessage/addApp'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/lookMessage/:id',
            name: 'lookMessage',
            component: resolve => require(['@/pages/appMessage/lookMessage'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/popMessage',
            name: 'popMessage',
            component: resolve => require(['@/pages/popMessage/index'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/editorPop',
            name: 'editorPop',
            component: resolve => require(['@/pages/popMessage/editorPop'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/addPop',
            name: 'addPop',
            component: resolve => require(['@/pages/popMessage/addPop'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/lookPop',
            name: 'lookPop',
            component: resolve => require(['@/pages/popMessage/lookPop'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        }, 
        {
            path: '/bannerPop',
            name: 'bannerPop',
            component: resolve => require(['@/pages/banner/index'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/editorBanner',
            name: 'editorBanner',
            component: resolve => require(['@/pages/banner/editor'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/addBanner',
            name: 'addBanner',
            component: resolve => require(['@/pages/banner/add'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/lookBanner',
            name: 'lookBanner',
            component: resolve => require(['@/pages/banner/look'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        }, 
        {
            path: '/member_coupon',
            name: 'activity',
            component: resolve => require(['@/pages/memberCoupon/index'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        }, {
            path: '/map-ride',
            name: 'mapRide',
            component: resolve => require(['@/pages/mapRide/index'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/add_map-ride',
            name: 'addRideLine',
            component: resolve => require(['@/pages/mapRide/addRideLine'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        }, 
        {
            path: '/gpx2geojson',
            name: 'gpx2geojson',
            component: resolve => require(['@/pages/mapRide/gpx2geojson'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        }, 
        {
            path: '/edit_map-ride/:id',
            name: 'editRideLine',
            component: resolve => require(['@/pages/mapRide/editRideLine'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        }, 
        {
            path: '/check_map-ride/:id',
            name: 'checkRideLine',
            component: resolve => require(['@/pages/mapRide/checkRideLine'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/scenicCourse',
            name: 'scenicCourse',
            component: resolve => require(['@/pages/scenicCourse/index'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/lookScenicCourse/:id',
            name: 'lookScenicCourse',
            component: resolve => require(['@/pages/scenicCourse/look'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/editScenicCourse/:id',
            name: 'editScenicCourse',
            component: resolve => require(['@/pages/scenicCourse/editor'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/addScenicCourse',
            name: 'addScenicCourse',
            component: resolve => require(['@/pages/scenicCourse/add'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/',
            name: 'login',
            component: resolve => require(['@/pages/login'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: false,
                showHeader: false,
            }
        },











        {
            path: '/collection',
            name: 'collection',
            component: resolve => require(['@/pages/collection/index'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/collection/editor/:id',
            name: 'collectionEditor',
            component: resolve => require(['@/pages/collection/editor'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
        {
            path: '/collection/add',
            name: 'collectioAadd',
            component: resolve => require(['@/pages/collection/add'], resolve),
            meta: {
                keepAlive: false,
                requireLogin: true,
                showHeader: true,
            }
        },
    ]
})
router.beforeEach((to, from, next) => {
    next();
})
export default router 